import axios from 'axios';

const state = {};

const getters = {};

const mutations = {};

const actions = {
  edit(state, payload) {
    return axios.patch(`/supporters/contacts`, payload)
      .then(({ data }) => {
        if (!!data.failures && data.failures.length > 0) {
          console.error('Edit contacts - ERROR - ', data.failures[0].error);
          throw data.failures;
        } else {
          return data.successes;
        }
      }).catch(err => { throw err });
  },
  add(state, payload) {
    return axios.post(`/supporters/contacts`, payload)
      .then(({ data }) => {
        if (!!data.failures && data.failures.length > 0) {
          console.error('Add contacts - ERROR - ', data.failures[0].error);
          throw data.failures;
        } else {
          return data.successes;
        }
      }).catch(err => { throw err });
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};